import { TMachineCategoryPageDataForPDP } from '@internal/page/TMachineCategoryPageData'
import { Machine } from '@internal/utils/machine/Machine'
import { TLocale } from '@internal/utils/machine/i18n/Locale'
import React from 'react'
import { BackButton } from './BackButton'
import { BreadCrumb } from './BreadCrumb/BreadCrumb'
import styles from './machineOverviewBlock.module.scss'

interface Props {
  locale: TLocale
  hideBackButton?: boolean
  machine: Machine
  machineCategoryPages: {
    forMachineType: TMachineCategoryPageDataForPDP | null
    forMachineTypeAndBrand: TMachineCategoryPageDataForPDP | null
    forMachineTypeBrandAndModel: TMachineCategoryPageDataForPDP | null
  }
}

export const MachineOverviewBreadcrumb: React.FC<Props> = React.memo(
  ({ machine, locale, machineCategoryPages, hideBackButton = false }) => (
    <div className={styles.breadcrumbWrapper}>
      {!hideBackButton && (
        <BackButton
          machine={machine}
          locale={locale}
          machineCategoryPages={machineCategoryPages}
        />
      )}
      <BreadCrumb locale={locale} machineCategoryPages={machineCategoryPages} />
    </div>
  )
)

MachineOverviewBreadcrumb.displayName = 'MachineOverviewBreadcrumb'
